// extracted by mini-css-extract-plugin
export default {"container__selector":"selectorSwiper_container__selector__rNRsQ"};